module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "nac-company.269e0029.png";